import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useThumbnail } from '../../hooks/useThumbnail'

interface RotateConfirmDialogProps {
  show: boolean
  onHide: () => void
  onConfirm: (degrees: number) => void
  documentId?: number
}

export const RotateConfirmDialog: React.FC<RotateConfirmDialogProps> = ({ show, onHide, onConfirm, documentId }) => {
  const { t } = useTranslation()
  const [rotation, setRotation] = useState(0)
  const { blobUrl: thumbBlobUrl } = useThumbnail(documentId)

  const rotate = (clockwise: boolean = true) => {
    setRotation((prev) => prev + (clockwise ? 90 : -90))
  }

  const handleConfirm = () => {
    // Normalize degrees
    let degrees = rotation % 360
    if (degrees < 0) degrees += 360

    onConfirm(degrees)
    setRotation(0) // Reset rotation for next use
  }

  const handleCancel = () => {
    setRotation(0) // Reset rotation
    onHide()
  }

  return (
    <Modal show={show} onHide={handleCancel} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t('rotate_confirm') || 'Potvrda rotacije'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-2 d-flex justify-content-end">
            <Button variant="secondary" className="mt-auto" onClick={() => rotate(false)}>
              <i className="bi bi-arrow-counterclockwise"></i>
            </Button>
          </div>
          <div className="col-8 d-flex align-items-center">
            {documentId && thumbBlobUrl ? (
              <img className="w-75 m-auto" style={{ transform: `rotate(${rotation}deg)` }} src={thumbBlobUrl} alt="Document preview" />
            ) : documentId ? (
              <div className="w-75 m-auto d-flex align-items-center justify-content-center">
                <div className="spinner-border spinner-border-sm" role="status"></div>
              </div>
            ) : null}
          </div>
          <div className="col-2 d-flex">
            <Button variant="secondary" className="mt-auto" onClick={() => rotate(true)}>
              <i className="bi bi-arrow-clockwise"></i>
            </Button>
          </div>
        </div>
        <p className="small text-muted fst-italic mt-4">{t('rotate_pdf_note') || 'Napomena: samo PDF fajlovi će biti rotirani.'}</p>
        <div className="mt-3">
          <p>
            <strong>{t('rotate_confirm_message') || 'Ova operacija će trajno rotirati originalnu verziju odabranih dokumenata.'}</strong>
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          {t('cancel') || 'Otkaži'}
        </Button>
        <Button variant="danger" onClick={handleConfirm} disabled={rotation === 0}>
          {t('proceed') || 'Nastavi'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
